import { render, staticRenderFns } from "./lochus.vue?vue&type=template&id=c9b2591a&scoped=true&"
import script from "./lochus.vue?vue&type=script&lang=js&"
export * from "./lochus.vue?vue&type=script&lang=js&"
import style0 from "./lochus.vue?vue&type=style&index=0&id=c9b2591a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b2591a",
  null
  
)

export default component.exports